// components/misc/Modal.js
import React from "react";

const ModalConfirm = ({ isOpen, onCancel, onConfirm, children, title }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none focus:outline-none bg-black/50">
      {/* Changed back to bg-black/50 */}
      <div className="relative bg-white-500 shadow-lg border border-gray-400 w-[30%] h-[25%] rounded-md max-w-full max-h-full mx-auto my-6">
        {/* Modal Content */}
        <div className="relative flex flex-col w-full h-full bg-white border-0 rounded-lg shadow-lg outline-none focus:outline-none dark:bg-[#20293A]">
          {/* Modal Header */}
          <div className="flex items-start justify-between p-5 border-b border-solid rounded-t border-slate-200 dark:border-slate-700">
            <h3 className="text-xl font-semibold text-slate-900 dark:text-slate-200">
              {title}
            </h3>
          </div>
          {/* Modal Body */}
          <div className="relative flex-auto p-6 overflow-y-auto">
            {/* Removed ReactFlowProvider from here */}
            {children}
          </div>
          {/* Modal Footer */}
          <div className="flex items-center space-x-4 justify-end p-6 border-t border-solid rounded-b border-slate-200 dark:border-slate-700">
          <button
              className="px-6 rounded-md hover:bg-gray-300 py-2 bg-gray-200 mb-1 mr-1 text-sm font-bold text-gray-700 uppercase transition-all duration-150 ease-linear background-transparent focus:outline-none"
              type="button"
              onClick={onCancel}
            >
              No
            </button>
            <button
              className="px-6 rounded-md py-2 hover:bg-gray-300 bg-gray-200 mb-1 mr-1 text-sm font-bold text-red-600 uppercase transition-all duration-150 ease-linear background-transparent focus:outline-none"
              type="button"
              onClick={onConfirm}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalConfirm; // Updated export statement
